<template>
  <main class="bg_gray pattern">
    <div class="container margin_60_40">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="box_booking_2">
            <div class="head">
              <div class="title">
                <h3>Gnanams Hotel</h3>
                299, 301 Clock Tower Rd, Jaffna
              </div>
            </div>
            <!-- /head -->
            <!-- <Loader v-if="loading" :loading="loading" :success="loginSuccess" /> -->

            <div class="main back-white">
              <div class="row">

                <div class="col-lg-4">
                  <div class="row card " style="border:1px solid;border-radius:10px">
                    <div class="col-lg-12" style="font-size:12px;font-weight:bold">Guest Details</div>
                    <p></p>
                                              
              
                  <div class="row">
                    <div
                      class="col-lg-6 text-left"
                      v-if="
                        TableReservedDetails.guest &&
                          TableReservedDetails.guest.name
                      "
                    >
                    <i class="fas fa-user" style="color:var(--brand-primary);font-size:12px" >         </i> <b style="font-size:10px" >Name</b>
                  <br/>
                    </div>
                    <div
                      class="col-lg-6 text-right "
                      v-if="
                        TableReservedDetails.guest &&
                          TableReservedDetails.guest.name
                      "
                    >
                      {{ TableReservedDetails.guest.name }}
                    </div>
                    <div
                      class="col-lg-6 text-left"
                      v-if="
                        TableReservedDetails.guest &&
                          TableReservedDetails.guest.nic_number
                      "
                    >
                    <i class="fas fa-id-card" style="color:#c53a2a;font-size:12px"></i><b style="font-size:10px" >  Nic Number</b>
                    <br/>
                    </div>
                    <div
                      class="col-lg-6 text-right "
                      v-if="
                        TableReservedDetails.guest &&
                          TableReservedDetails.guest.nic_number
                      "
                    >
                      {{ TableReservedDetails.guest.nic_number }}
                    </div>
                    <div
                      class="col-lg-6 text-left"
                      v-if="
                        TableReservedDetails.guest &&
                          TableReservedDetails.guest.phone
                      "
                    >
        
                    <i class="fas fa-phone-square" style="font-size:12px" ></i><b style="font-size:10px" >  Phone Number</b>
                <br/>
                    </div>
                    <div
                      class="col-lg-6 text-right  "
                      v-if="
                        TableReservedDetails.guest &&
                          TableReservedDetails.guest.phone
                      "
                    >
                      {{ TableReservedDetails.guest.phone }}
                    </div>
                  </div>
                  </div>
      
                </div>
                <div class="col-lg-4">
                  <div class="row card" style="border:1px solid;border-radius:10px">
            
                    <div class="col-lg-12" style="font-size:12px;font-weight:bold">Table order details</div>
                    <p></p>
                          <div class="row">
                    <div class="col-lg-6 text-left ">
                      <i class="fas fa-calendar-day" style="color:#c4276c;font-size:10px"></i>  <b style="font-size:10px"> Date</b>
                  <br/>
                    
                
                    </div>
                    <div class="col-lg-6 text-right">
                      {{ TableReservedDetails.date | formatDate }}
                    </div>
                    <div class="col-lg-6 text-left">
                      <i class="fas fa-business-time" style="font-size:10px;color: #ffb308"></i>
                      <b style="font-size:10px">Time</b>
                    </div>
                    <br/>
                    <div class="col-lg-6 text-right" style="font-weight:bold">
                      {{ TableReservedDetails.date | formatTime }}
                    </div>
                    <div class="col-lg-6 text-left ">
                      <i class="fas fa-dice-d6" style="font-size:10px"></i>
                      <b style="font-size:10px"> Type</b>
                      <br/>
                    </div>
                    <div class="col-lg-6 text-right " style="font-weight:bold;color:#1a8917" >
                      {{ TableReservedDetails.order_type ? "Dine In" : "-" }}
                    </div>
                    <div
                      class="col-lg-6 text-left "
                      v-if="
                        TableReservedDetails.waiter &&
                          TableReservedDetails.waiter.name
                      "
                    >
                    <i class="fas fa-id-card-alt" style="font-size:10px;color:#242c67"></i>
                      <b style="font-size:10px"> Waiter</b>
                    </div>
                    <br/>
                    <div
                      class="col-lg-6 text-right "
                      v-if="
                        TableReservedDetails.waiter &&
                          TableReservedDetails.waiter.name
                      "
                    >
                      {{ TableReservedDetails.waiter.name }}
                    </div>
                    <div
                      class="col-lg-6 text-left"
                      v-if="TableReservedDetails && TableReservedDetails.guest"
                    >
                    <i class="fas fa-user" style="font-size:10px;color:var(--brand-primary)"></i>
                      <b style="font-size:10px"> Guest</b>
                    </div>
                    <br/>
                    <div
                      class="col-lg-6 text-right"
                      v-if="TableReservedDetails && TableReservedDetails.guest"
                    >
                      {{ TableReservedDetails.guest.name }}
                    </div>
                  </div>
            
                  </div>








                
            
                </div>
                <div class="col-lg-4">
                  <div class="row card"  style="border:1px solid;border-radius:10px">
                           <div class="col-lg-12" style="font-size:12px;font-weight:bold">Table Details</div>
                                     <div class="row">
                    <div
                      class="col-lg-6 text-left"
                      v-if="
                        TableReservedDetails.table &&
                          TableReservedDetails.table.name
                      "
                    >
                    <i class="fas fa-table" style="font-size:12px;color:var(--brand-primary)"></i>
                      <b style="font-size:10px"> Table name</b>
                    </div>
                    <div
                      class="col-lg-6 text-right"
                      style="font-weight:bold;color:red"
                      v-if="
                        TableReservedDetails.table &&
                          TableReservedDetails.table.name
                      "
                    >
                      {{ TableReservedDetails.table.name }}
                    </div>
                    <div
                      class="col-lg-6  text-left"
                      v-if="
                        TableReservedDetails.table &&
                          TableReservedDetails.table.event_date
                      "
                    >
                    <i class="far fa-calendar-plus" style="font-size:12px;color:#c11f66"></i>
                      <b style="font-size:10px"> Event date</b>
                    </div>
                    <div
                      class="col-lg-6 text-right "
                      style="font-weight:bold;color:#c11f66"
                      v-if="
                        TableReservedDetails.table &&
                          TableReservedDetails.table.event_date
                      "
                    >
                      {{ TableReservedDetails.table.event_date | formatDate }}
                    </div>
                  </div>


                  </div>
              
        
                </div>
              </div>
          

              <div class="layout">
                <input
                  name="nav"
                  type="radio"
                  class="Orders-radio"
                  id="Orders"
                  checked="checked"
                />
                <div class="page home-page">
                  <div class="page-contents">
                
                    <div class="row">
                      <div class="col-md-12">
                        <!-- Recent Orders -->
                        <div class="card">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table
                                class="datatable table table-hover table-center mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Item</th>
                                    <th>Unit</th>

                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Ingredients Total</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr
                                    v-for="(item,
                                    index) in TableReservedDetails.items"
                                  >
                                    <td v-if="item.dish">
                                      {{ item.dish.name }}
                                      <table class="width-100perc">
                                        <tbody>
                                          <tr
                                            v-for="(ingredient,
                                            index) in item.ingredients"
                                            :key="index"
                                            class="secondry-color text-left"
                                          >
                                            <td width="20px" class="text-right">
                                              +
                                            </td>
                                            <td>
                                              Add {{ ingredient.name }} ({{
                                                ingredient.amount
                                              }})
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                    <td v-if="item.product">
                                      {{ item.product.name }}
                                    </td>
                                    <td v-if="item.unit">
                                      {{ item.unit.name }}
                                    </td>

                                    <td>{{ item.amount }}</td>
                                    <td v-if="item.adjust_quantity <= 0">{{ item.quantity }}</td>
                                    <td   v-if="item.adjust_quantity > 0">{{ item.adjust_quantity }}g</td>
                                    <td>
                                      {{
                                        item.ingredient_amount
                                          ? item.ingredient_amount
                                          : 0
                                      }}
                                    </td>
                                    <td style="text-align: -webkit-center;">
                                      {{ item.amount * item.quantity }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- /Recent Orders -->
                      </div>
                    </div>
                  </div>
                </div>

                <label class="nav" for="Orders">
                  <span> Orders </span>
                </label>

                <input
                  name="nav"
                  type="radio"
                  class="Payments-radio"
                  id="Payments"
                />
                <div class="page contact-page">
                  <div class="page-contents">
                  
                    <div class="row">
                      <div class="row">
                        <div class="col-lg-6 text-left"><b style="font-size:12px"> Total Amount</b></div>
                        <div class="col-lg-6 " style="color:green">
                          {{
                            TableReservedDetails.total_amount | formatCurrency
                          }}
                        </div>

                        <div class="col-lg-6 text-left"><b style="font-size:12px">Pending Payment</b></div>
                        <div class="col-lg-6 " style="color:red">
                          {{
                            (TableReservedDetails.total_amount -
                              TableReservedDetails.paid_amount)
                              | formatCurrency
                          }}
                        </div>
                      </div>
                      <div></div>
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-lg-10"></div>
                          <div class="  col-lg-2 buttonpay">
                            <button
                            style="border-radius:3px;background-color:var(--brand-primary)"
                              v-if="
                                TableReservedDetails.total_amount !=
                                  TableReservedDetails.paid_amount
                              "
                              @click="
                                makePaymentQuick(
                                  'modal-payment-pend' + TableReservedDetails.id
                                )
                              "
                              class="Pay"
                            >
                              Pay
                            </button>
                          </div>
                        </div>
                        <!-- Recent Orders -->
                        <div class="card">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table
                                class="datatable table table-hover table-center mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Date</th>
                                    <th>Reference Number</th>

                                    <th>Payment Type</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr
                                    v-for="(payment,
                                    index) in TableReservedDetails.payment"
                                  >
                                    <td>
                                      {{ payment.date_time | formatDate }}
                                    </td>
                                    <td>
                                      {{
                                        payment.reference_number
                                          ? payment.reference_number
                                          : "-"
                                      }}
                                    </td>

                                    <td>{{ payment.payment_type }}</td>
                                    <td>
                                      {{ payment.amount | formatCurrency }}
                                    </td>
                                    <td>{{ payment.status }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- /Recent Orders -->
                      </div>
                    </div>
                  </div>
                </div>
                <label class="nav" for="Payments">
                  <span> Payments </span>
                </label>
              </div>
              <!-- <button :disabled="!paymentType" class="btn_1 full-width mb_5" @click="CompleteOrder()" >Complete</button> -->
          <div class="row justify-content-end" style="margin-left:">     <a
                class="btn_1  mb_5"
                style="color:white;background-color:#76c659;margin-right:10px"
                @click="makePayment('modal-payment-' + TableReservedDetails.id)"
                >Complete Order</a
              >
              <a
                class="btn_1  mb_5 Orderbutton"
                style="color:white;background-color:var(--brand-primary)"
                @click="
                  clickToFoodOrder(
                    TableReservedDetails.table.id,
                    TableReservedDetails.table.order
                  )
                "
                >Add More Foods
              </a></div>
          

              <div class=" row justify-content-end">
                <small>No payment is taken on this step.</small>
              </div>
            </div>
          </div>
          <!-- /box_booking -->
        </div>
        <!-- /col -->
      </div>
      <!-- /row -->
      <CModal
        Text="Checkout Bill"
        ref="Payment"
        headerText="Bill"
        :width="900"
        submitText="Conform"
        :hideButton="true"
        :visibleFooter="false"
        :modalName="'modal-payment-' + TableReservedDetails.id"
      >
        <template v-slot:content>
          <div class="row row_style">
            <div class="col-6">
              Customer
            </div>
            <div class="col-6">
              <strong v-if="TableReservedDetails && TableReservedDetails.guest">
                {{ TableReservedDetails.guest.name }}</strong
              >
            </div>
          </div>
          <div class="row row_style">
            <div class="col-6">
              Total Amount
            </div>
            <div class="col-4">
              <strong class="width-100perc">{{
                TableReservedDetails.total_amount
              }}</strong>
              <div v-if="istotaldiscount">
                <input
                  min="0"
                  type="number"
                  oninput="validity.valid||(value='');"
                  v-model="total_discount"
                  required=""
                  class="width-100perc"
                  placeholder="Discount"
                />
                <input
                  type="text"
                  v-model="remarks"
                  required=""
                  class="width-100perc"
                  placeholder="Note"
                />
              </div>
            </div>
            <div class="col-2">
              <lable
                >Discount

                <input
                  type="checkbox"
                  v-model="istotaldiscount"
                  required=""
                  class="width-100perc ges-data-coupon-code"
                  placeholder=""
                />
              </lable>
            </div>
          </div>
          <div
            class="row row_style"
            v-if="TableReservedDetails.order_type != 'take_away'"
          >
            <div class="col-6">
              <div v-if="servicecharge">
                Service Charge({{ service_charge }}%)
              </div>
            </div>
            <div class="col-4">
              <strong>{{ servicecharge }}</strong>

              <input
                v-if="isservicecharge"
                min="0"
                type="number"
                oninput="validity.valid||(value='');"
                v-model="service_discount"
                required=""
                class="width-100perc"
                placeholder=""
              />
            </div>
            <div class="col-2">
              <lable
                >Discount

                <input
                  type="checkbox"
                  v-model="isservicecharge"
                  required=""
                  class="width-100perc ges-data-coupon-code"
                  placeholder=""
                />
              </lable>
            </div>
          </div>
          <div class="row row_style" v-if="grandtotal_amount">
            <div class="12">
              <p class="margin-bottom-0px">
                <strong v-if="grandtotal_amount"> Grand Amount</strong>
              </p>

              <!-- <p class="width-100perc"></p> -->
            </div>
          </div>
          <div class="row row_style">
            <div class="col-6">
              <p class="margin-bottom-0px">Payment Method</p>
            </div>
            <div class="col-6">
              <select
                v-model="paymentType"
                class="width-100perc ges-data-coupon-code payment-type"
                placeholder="Payment Method"
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
              </select>

              <div class="" v-if="paymentType == 'Card'">
                <p class="margin-bottom-0px">Enter Bank</p>
                <input
                  type="text"
                  v-model="bank"
                  required=""
                  class="width-100perc ges-data-coupon-code"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div class="row row_style">
            <div class="col-6">
              Payable Amount
            </div>
            <div class="col-4">
              <strong class="width-100perc">{{ payableAmount }}</strong>
            </div>
          </div>

          <div class="row">
            <button @click="SubmitBill()" class="btnComplete" :disabled="Paymentdisable">
              {{ isSuspend ? "SuspendBill" : "Complete Bill" }}
            </button>
          </div>
        </template>
      </CModal>

      <CModal
        Text="customize"
        ref="PaymentQuick"
        headerText="Payments"
        submitText="pay"
        :hideButton="true"
        @onClickSubmit="makePaymentDetails()"
        :visibleFooter="true"
        :width="950"
        :modalName="'modal-payment-pend' + TableReservedDetails.id"
      >
        <template v-slot:content>
          <div class="row">
            <div class="col-lg-12">
        
              <div class="container">
                <div class="row">
              
                    <div class="col-lg-3 text-left">Total Payable Amount</div>
                    <div class="col-lg-3">  {{
                      (TableReservedDetails.total_amount -
                        TableReservedDetails.paid_amount)
                        | formatCurrency
                    }}</div>
                    <div class="col-lg-3">Payment Type</div>
                    <div class="col-lg-3">            <Multiselect
                      v-model="Payment.payment_type"
                      selectLabel=""
                      :options="PaymentTypes"
                      placeholder="Payment Type"
                      track-by="name"
                      label="name"
                      ><span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                      >
                      <template slot="singleLabel" slot-scope="{ option }">
                        {{ option.name }}
                      </template>
                    </Multiselect></div>






              
                  
                    <div class="col-lg-3 text-left">Amount</div>
                      <div class="col-lg-3">  <input
                      class="form-control"
                      placeholder="Amount"
                      v-model="Payment.amount"
                      min="0"
                      type="number"
                      oninput="validity.valid||(value='');"
                    />

                    <label
                      style="color:red"
                      v-if="
                        Payment.amount >
                          TableReservedDetails.total_amount -
                            TableReservedDetails.paid_amount
                      "
                    >
                      You Entered Amount Greater Than TotalAmount</label
                    ></div>
                        <div class="col-lg-3 text-center"   v-if="Payment.payment_type.name === 'Card'"> Bank</div>
                          <div class="col-lg-3"   v-if="Payment.payment_type.name === 'Card'">        <input
                      class="form-control"
                      placeholder="Bank"
                      v-model="Payment.card_bank"
                    /></div>





                














              
              
                
            

              
                
                </div>
                  <div class="row" style="margin-top:15px">
                    <div class="col-lg-3 text-left">Note</div>
                    <div class="col-lg-9 " style="margin-bottom:15px">    <input
                      class="form-control paragraph"
                      placeholder="Note"
                      v-model="Payment.remarks"
                    /></div>
                  </div>
              </div>
            </div>
          </div>
        </template>
      </CModal>

      <Bill
        v-if="!IsPartiallyBill"
        :Order="TableReservedDetails"
        :EventTable="true"
        :paymentAmount="payableAmount"
        v-show="false"
        :paymentType="paymentType"
        ref="Bill"
      />

      <PartiallyBill
        v-if="IsPartiallyBill"
        :Order="TableReservedDetails"
        :EventTablePartial="true"
        :paymentAmount="Payment.amount"
        v-show="false"
        :paymentType="Payment.payment_type"
        ref="PartiallyBill"
      />
    </div>

    <!-- /container -->
  </main>
</template>

<script>
import Bill from "../components/Share/Bill/index";
import PartiallyBill from "../components/Share/Bill/index";

import Multiselect from "vue-multiselect";

import { CustomModal as CModal } from "@/components/base/index.js";

import { Loader } from "@/components/base/index.js";
const iconComponent = {
  template: `
        <span class="my-icon">{{ opened ? 'I am open' : ' I am closed' }}</span>
    `,
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  }
};

import VueRangeSlider from "vue-range-component";
import "vue-range-component/dist/vue-range-slider.css";
import axios from "@/plugins/axios";
import moment from "moment";
import { mapState } from "vuex";
import { isTableLockedToOtherWaiter } from "@/utils/permissions";

export default {
  name: "Home",
  data() {
    return {
      iconComponent: iconComponent,
      TableReservedDetails: [],
      isSuspend: false,
      Paymentdisable: false,
      IsPartiallyBill: false,
      Payment: {
        payment_type: "",
        amount: null,
        date_time: moment().format("YYYY-MM-DD"),
        remarks: ""
      },
      PaymentTypes: [
        {
          name: "Card"
        },
        {
          name: "Cash"
        }
      ],
      note: null,
      TableIdVisible: true,
      paymentAmount: 0,
      note: null,
      loginSuccess: false,
      completeBill: false,
      loading: false,
      paymentType: null,
      bank: null,
      service_charge: null,
      isservicecharge: false,
      servicecharge: null,
      grandtotal_amount: null,
      TableId: null,
      istotaldiscount: false,
      total_discount: 0,
      service_discount: 0
    };
  },
  components: {
    Loader,
    CModal,

    Multiselect,
    Bill,
    PartiallyBill
  },
  methods: {
    //Adding More Foods For This Event Table
    clickToFoodOrder(index, items) {
      if (isTableLockedToOtherWaiter(this.$store.state.auth, items)) {
        const name = (items.waiter && items.waiter.name) || "another waiter";
        this.$fire({
          title: "Table locked",
          text: `This table is picked by ${name}.`,
          type: "error",
          timer: 3000,
        });
        return;
      }
      if (items) {
        this.$store.commit("orders/AddGuestDetails", items.guest);
      }

      this.$router.push("/order/table/" + index);
    },

    // Open CheckOut Payment Popup Modal
    makePayment(modalName) {
      this.servicecharge =
        (this.TableReservedDetails.total_amount * this.service_charge) / 100;
      this.$refs.Payment.show(modalName);
    },

    //Open Partially Payment (Advance Payment)For Event Table
    makePaymentQuick(modalName) {
      this.$refs.PaymentQuick.show(modalName);
    },
    //MAke Partially Payment (Advance Payment)For Event Table
    makePaymentDetails() {
      if (this.Payment.amount > 0) {
        let credential = this.Payment;

        this.IsPartiallyBill = true;
        credential.payment_type = this.Payment.payment_type.name;

        axios
          .post(
            `hms/web/orders/${this.TableReservedDetails.id}/payments`,
            credential
          )
          .then(res => {
            this.GetTableReservedDetails();

            this.$refs.PartiallyBill.print();
            this.IsPartiallyBill = false;
            this.$refs.PaymentQuick.hide();
            this.Payment.amount = null;
          })
          .catch(err => {});
      }
    },
    //  CheckOut Payment Functions
    async CompleteOrder() {
      this.loading = true;
      let Credentials = new Object();
      Credentials.reference_number = "sample";
      Credentials.date_time = moment(new Date()).format("MM/DD/YYYY HH:MM");
      Credentials.payment_type = this.paymentType;
      Credentials.descount =
        parseFloat(this.service_discount) + parseFloat(this.total_discount);
      if (this.TableReservedDetails.order_type != "take_away") {
        Credentials.service_charge = (
          (parseFloat(this.TableReservedDetails.total_amount) *
            parseFloat(this.service_charge)) /
          100
        ).toFixed(0);
      }
      Credentials.remarks = this.remarks;
      if (this.paymentType == "Card") {
        Credentials.card_bank = this.bank;
      }

      if (this.isSuspend) {
        Credentials.amount = this.paymentAmount;
        Credentials.remarks = this.note;
      } else {
        Credentials.amount = this.payableAmount;
      }
      Credentials.remarks = null;


      this.Paymentdisable= true;
      axios
        .post(
          `hms/web/orders/${this.TableReservedDetails.id}/payments`,
          Credentials
        )
        .then(res => {
          ;
          this.loginSuccess = true;
          this.completeBill = true;
          this.$refs.Payment.hide();

          let promise = this.GetTableReservedDetails();
          promise.then(res => {
            ;
            this.TableId = this.$route.params.id;
            this.$store.commit("orders/AddOrderTableDetails", this.TableId);
            this.$store.commit(
              "orders/AddOrderTableDetailsVisible",
              this.TableIdVisible
            );
            this.$refs.Bill.print();
            this.$router.push("/");
          });
        })
        .catch(err => {});
    },
    // If  Click Submit Button To CheckOut To Validation Checking
    SubmitBill() {
      if (!this.paymentType) {
        this.$fire({
          title: "Error",
          text: "Please Select a Payment Type",
          type: "error",
          timer: 3000
        }).then(r => {});
      } else if (this.paymentType == "Card" && !this.bank) {
        this.$fire({
          title: "Error",
          text: "Please Enter the Bank Name",
          type: "error",
          timer: 3000
        }).then(r => {});
      } else if (this.isSuspend && !this.note) {
        this.$fire({
          title: "Error",
          text: "Please Enter the Note to suspend",
          type: "error",
          timer: 3000
        }).then(r => {});
      } else {
        this.CompleteOrder();
      }
    },
    //Getting Event Table All Details
    GetTableReservedDetails() {
      return new Promise((resolve, reject) => {
        let id = this.$route.params.id;
        axios
          .get(`hms/web/orders/${id}`)
          .then(res => {
            this.TableReservedDetails = res.data;
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  created() {
    this.GetTableReservedDetails();
    this.service_charge = this.setting && this.setting.service_charge;
  },
  filters: {
    price: function(value) {
      return value.toFixed(2);
    }
  },
  computed: {
    ...mapState("sitesetting", ["setting"]),
    //Payable Amount Calculation For Final Bill
    payableAmount() {
      let ServiceCharge = 0;
      if (this.TableReservedDetails.order_type != "take_away") {
        ServiceCharge = (
          (this.TableReservedDetails.total_amount * this.service_charge) /
          100
        ).toFixed(0);
      }
      let TotalDiscount = 0;
      let ServiceDiscount = 0;

      if (this.istotaldiscount) {
        TotalDiscount = this.total_discount;
      }
      if (this.isservicecharge) {
        ServiceDiscount = this.service_discount;
      }
      console.log("ISTOTAL DISCOUNT", this.service_discount);

      return (
        this.TableReservedDetails.total_amount +
        (ServiceCharge - TotalDiscount - ServiceDiscount) -
        this.TableReservedDetails.paid_amount
      );
    }
  }
};
</script>

<style scoped>
.row {
  margin-right: 9px !important;
  margin-left: 9px !important;
}
.row_style {
  background: #f3f3f3;
  padding: 12px;

  border-radius: 16px;
  margin: 0 80px 9px;
}
.btnComplete {
  background: var(--brand-primary);
  padding: 15px 25px;
  width: 80%;
  margin: 20px auto !important;
  color: white !important;
  font-size: 15px !important;
  border: none;
  outline: none;
  border-radius: 14px;
}
.buttonpay {
  margin-bottom: 10px;
}
.payment-type {
  height: 42px;
  padding: 0 13px;
}
.StatusColor {
  height: 23px;
  width: 100px;
  border-radius: 20px;
  background: rgb(51, 145, 51);
  color: #d6d6d6;
  margin-bottom: 10px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
}
.pendingpayment {
  height: 23px;
  width: 100px;
  border-radius: 20px;
  background: rgb(182, 57, 41);
  color: #d6d6d6;
  margin-bottom: 10px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
}
.payableAmount {
  height: 23px;
  width: 100px;
  border-radius: 20px;
  background: green;
  color: #d6d6d6;
  margin-bottom: 10px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
}
.ButtonEdit {
  height: 28px;
  width: 65px;
  border-radius: 20px;
  background: rgb(189 188 188);
  margin-bottom: 10px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
}
.UpdateButton {
  height: 28px;
  width: 75px;
  border-radius: 20px;
  background: rgb(131 216 33);
  margin-bottom: 10px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
}
.Orderbutton {
  background: #c4c124;
  outline: none;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  padding: 8px 25px;
  color: rgb(255, 253, 253);
  font-weight: 500;
  text-align: center;
  font-size: 14px;
  font-size: 0.875rem;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border-radius: 3px;
  line-height: normal;
}
.Cancelbutton {
  background: #e7725d;
  outline: none;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  padding: 8px 25px;
  color: rgb(255, 253, 253);
  font-weight: 500;
  text-align: center;
  font-size: 14px;
  font-size: 0.875rem;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border-radius: 3px;
  line-height: normal;
 
}
.imgContainer {
  max-width: 1200px;
  margin: 10px auto;
  padding: 0px;
}
h1 {
  font-size: 20px;
  text-align: center;
  margin: 20px 0 20px;
}
h1 small {
  display: block;
  font-size: 15px;
  padding-top: 8px;
  color: gray;
}
.avatar-upload {
  position: relative;
  max-width: 205px;
  margin: 50px auto;
}
.avatar-upload .avatar-edit {
  position: absolute;
  right: 12px;
  z-index: 1;
  top: 10px;
}
.avatar-upload .avatar-edit input {
  display: none;
}
.avatar-upload .avatar-edit input + label {
  display: inline-block;
  width: 34px;
  height: 34px;
  margin-bottom: 0;
  border-radius: 100%;
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  font-weight: normal;
  transition: all 0.2s ease-in-out;
}
.avatar-upload .avatar-edit input + label:hover {
  background: #f1f1f1;
  border-color: #d6d6d6;
}
.avatar-upload .avatar-edit input + label:after {
  content: "\f040";
  font-family: "FontAwesome";
  color: #757575;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto;
}
.avatar-upload .avatar-preview {
  width: 192px;
  height: 192px;
  position: relative;
  border-radius: 100%;
  border: 6px solid #f8f8f8;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
.avatar-upload .avatar-preview > div {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.Pay {
  height: 34px;
  width: 65px;
  border-radius: 20px;
  color: #d6d6d6 !important;
  background: rgb(17, 80, 25);
  margin-bottom: 10px;
  box-shadow: none;
  border: none;
}

.headers {
  text-align: start !important;
  font-size: 14px;
}

.row {
  margin-right: -15px;
  margin-left: -15px;
}

.width-100perc {
  width: 100% !important;
}

.modal-body input[type="text"] {
  margin-bottom: 5px;
}

input[type="text"],
input[type="password"],
textarea,
input[type="tel"],
input[type="email"],
input[type="number"] {
  padding: 7px;
  border: 1px #e5e5e5 solid;
  margin-top: 2px;
  border-radius: 3px;
  /* border-bottom: #e5e5e5 2px solid; */
}

.margin-bottom-0px {
  margin-bottom: 0px !important;
}

.margin-top-15px {
  margin-top: 15px !important;
}

.card {
  border: 1px solid #f0f0f0;
  margin-bottom: 1.875rem;
}

.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-body {
  padding: 1.5rem;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}

.table-responsive {
  white-space: nowrap;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

div.dataTables_wrapper div.dataTables_length select {
  width: auto;
  display: inline-block;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^="col-"]:last-child {
  padding-right: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^="col-"]:last-child {
  padding-right: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^="col-"]:first-child {
  padding-left: 0;
}

.table.dataTable {
  border-collapse: collapse !important;
}

table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
  border-spacing: 0;
}

.table {
  color: #333;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table thead {
  background-color: #f8f9fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

table.dataTable thead > tr > th.sorting_asc {
  padding-right: 30px;
  cursor: pointer;
  position: relative;
}

.table.table-center th {
  vertical-align: middle;
}

.table thead tr th {
  font-weight: 600;
  border: 0;
}

table.dataTable th {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

table.dataTable thead > tr > th.sorting {
  padding-right: 30px;
  cursor: pointer;
  position: relative;
}

.table.table-center th {
  vertical-align: middle;
}

.table thead tr th {
  font-weight: 600;
  border: 0;
}

table.dataTable th {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

th {
  text-align: inherit;
}

.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.table.table-center td {
  vertical-align: middle;
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
}

table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}

h2 {
  font-family: "Mada", sans-serif;
  margin-top: 0;
}

h2 {
  font-size: 2rem;
}

.table.table-center td {
  vertical-align: middle;
}

table.dataTable td {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
}

table.table td h2 a {
  color: #333;
}

.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}

.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem;
}

a {
  transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}

a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}

.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}

table.table td h2 a {
  color: #333;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

th {
  text-align: inherit;
}

.top {
  margin-top: -195px !important;
}

.vm--modal {
  position: relative;
  overflow: visible !important;
  box-sizing: border-box;
  background-color: white;
  border-radius: 3px;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}

.modal_header,
.modal_footer {
  width: 100% !important;

  left: 0px !important;
}

* {
  list-style: none;
}

.booked {
  filter: grayscale(1);
}

.checkout {
  width: 100%;
  height: 38px;
  color: aquamarine;
  background-color: #ffffff;
  border-radius: 31px;
}

.checkout:active {
  width: 100%;
  height: 38px;
  color: aquamarine !important;
  background-color: #ffffff !important;
  border-radius: 31px;
}
.mb {
  margin-bottom: 20px !important;
}</style
><style lang="scss" scoped>
label,
a {
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  display: inline-block;
  color: inherit;
  transition: border 0.2s;
  border-bottom: 5px solid var(--brand-primary-fade-20);
  padding: 3px 2px;

  &:hover {
    border-bottom-color: var(--brand-primary);
  }
}

.layout {
  display: grid;
  height: 100%;
  width: 100%;
  overflow: hidden;
  grid-template-rows: 30px;
  grid-template-columns: 1fr 1fr;
}

input[type="radio"] {
  display: none;
}

label.nav {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-bottom: 2px solid var(--brand-primary);
  background: #ecf0f1;
  user-select: none;
  transition: background 0.4s, padding-left 0.2s;
  padding-left: 0;
  border-radius: 10px 10px 0px 0px;
  min-height: 30px !important;

  input[type="radio"]:checked + .page + & {
    background: var(--brand-primary);
    color: #ffffff;
    padding-left: 20px;

    span {
      padding-left: 20px;
    }

    svg {
      opacity: 1;
    }
  }

  span {
    padding-left: 0px;
    position: relative;
  }

  svg {
    left: 0;
    top: -3px;
    position: absolute;
    width: 15px;
    opacity: 0;
    transition: opacity 0.2s;
  }
}

.page {
  grid-column-start: 1;
  grid-row-start: 2;
  grid-column-end: span 4;
  padding: 0px 20px;
  display: flex;
}

.page-contents > * {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.2s, transform 0.2s;
  margin-top: 20px;

  @for $c from 1 through 20 {
    &:nth-child(#{$c}) {
      transition-delay: 0.2s + ($c * 0.2s);
    }
  }
}

input[type="radio"] + .page {
  transition: transform 0.2s;
  transform: translateX(100%);
}

input[type="radio"]:checked + .page {
  transform: translateX(0%);

  .page-contents > * {
    opacity: 1;
    transform: translateY(0px);
  }
}

.page-contents {
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
}
</style>
